export default __webpack_public_path__ + "static/media/Path 5451.4a34bb89.svg";